import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import YouTube from 'react-youtube';
import logo from '../images/logo.png';
import {allSongs} from '../scripts/songs';
import songs from '../scripts/years.min';
import YearSelector from './YearSelector';

const opts = {
  height: '270',
  width: '480',
  playerVars: { // https://developers.google.com/youtube/player_parameters
  	autoplay: 1,
    modestbranding: 1,
    rel: 0
  }
};

class Secondary extends Component {
	  constructor(props) {
	    super(props);
	    this.state = {
	      currentVideo: [],
	      playlist: [],
	      player: null,
	      value: '',
	      matches: null
	    };

	    this.onReady = this.onReady.bind(this);
	    this.onEnd = this.onEnd.bind(this);
	    this.videoClick = this.videoClick.bind(this);
	    this.addToPlaylistClick = this.addToPlaylistClick.bind(this);
	    this.clearPlaylist = this.clearPlaylist.bind(this);
	    this.skipSong = this.skipSong.bind(this);
	    this.prevSong = this.prevSong.bind(this);
	    this.findMatches = this.findMatches.bind(this);
	    this.handleInputChange = this.handleInputChange.bind(this);
	  }

	  componentDidMount() {
	  	document.querySelector('body').classList.remove('active');
	  	try {
	  		const json = localStorage.getItem('playlist');
		  	const playlist = JSON.parse(json);

		  	if(playlist.length > 0) {
		  		document.querySelector('body').classList.add('active');
		  		this.setState(() => ({playlist, currentVideo: playlist[0]}));
		  	}
	  	} catch(e) {

	  	}	
	  }

	  componentDidUpdate(prevProps, prevState) {
	  	if(this.state.playlist.length !== prevState.playlist.length) {
	  		const json = JSON.stringify(this.state.playlist);
	  		localStorage.setItem('playlist', json);
	  	}
	  }

	  onReady(event) {
	    this.setState(() => {
	    	return {
	    		player: event.target
	    	}
	    })
	    event.target.setVolume(1);
	  }

	  onEnd(event) {
	  	this.skipSong();
	  }

	  skipSong() {
	  	const playlist = this.state.playlist;
	  	const playlistIDX = playlist.indexOf(this.state.currentVideo);

	  	if(playlist.length === 0) {
	  		const currentYearSongs = songs['_' + this.props.year];
			this.setState(() => {
				return {
					currentVideo: currentYearSongs[Math.floor(Math.random() * currentYearSongs.length)]
				}
			})
	  	} else if(playlistIDX === 0 && playlist.length === 1) {
	  		this.setState(() => {
	  			return {
	  				currentVideo: []
	  			}
	  		}, () => {
	  			this.setState(() => {
	  				return {
	  					currentVideo: playlist[playlistIDX]
	  				}
	  			})
	  		})
	  	} else if(playlistIDX + 1 === playlist.length) {
	  		this.setState(() => {
	  			return {
	  				currentVideo: playlist[0]
	  			}
	  		})
	  	} else {
	  		this.setState(() => {
	  			return {
	  				currentVideo: playlist[playlistIDX+1]
	  			}
	  		})
	  	}
	  }

	  prevSong() {
	  	const playlist = this.state.playlist;
	  	const playlistIDX = playlist.indexOf(this.state.currentVideo);

	  	if(playlistIDX > 0) {
	  		this.setState(() => {
	  			return {
	  				currentVideo: playlist[playlistIDX-1]
	  			}
		  	})
		} else if(playlistIDX < 1 && playlist.length > 0) {
	  		this.setState(() => {
	  			return {
	  				currentVideo: playlist[playlist.length - 1]
	  			}
	  		})
	  	} else {
			const currentYearSongs = songs['_' + this.props.year];
			this.setState(() => {
				return {
					currentVideo: currentYearSongs[Math.floor(Math.random() * currentYearSongs.length)]
				}
			})
		}  		 
	  }

	  videoClick(videoToPlay) {
	  	document.querySelector('body').classList.add('active');

	  	this.setState(() => {
	  		return {
	  			currentVideo: videoToPlay
	  		}
	  	});
	  }

  	  addToPlaylistClick(videoToPlay) {
  	  	if(this.state.player && this.state.playlist.indexOf(videoToPlay) < 0) {
  	  		if(this.state.player.getPlayerState()===5 || this.state.player.getPlayerState()===0) {
		  		this.setState((prevState) => {
			  		return {
			  			playlist: [...prevState.playlist, videoToPlay],
			  			currentVideo: videoToPlay
			  		}
		  		})
		  		document.querySelector('body').classList.add('active');
		  	} else {
		  		this.setState((prevState) => {
			  		return {
			  			playlist: [...prevState.playlist, videoToPlay]
			  		}
		  		})
		  	}

  	  	}

  		document.querySelector('#header-now-playing').classList.add('animated', 'flash')
  		setTimeout(() => {
  			document.querySelector('#header-now-playing').classList.remove('animated', 'flash');
  		}, 500)

	  }

	  clearPlaylist() {
	  	this.setState(() => {
	  		return {
	  			playlist: []
	  		}
	  	})
	  }

	  handleInputChange(event) {
	  	let value = event.target.value.match(/[a-z0-9\s]/gi);
	  	
	  	if(!value) {
	  		return this.setState(() => ({matches: null, value: ''}))
	  	} else if(value.join('').trim()) {
	  		value = value.join('');
	  		this.setState(() => ({value}), this.findMatches);
	  	}
	  }

	findMatches() {
		const query = this.state.value.trim();

		if(query.length > 2) {
			this.setState(() => {
				return {
					matches: allSongs.filter(el => {const regex = new RegExp(query, 'gi'); return el[0].match(regex) || el[1].match(regex)})
				}
			})
		}
	}

  	render() {
	    return (
	      <div>
	        <SecondaryHeader />

	        <aside>
	    	
		     <YouTube opts={opts} videoId={this.state.currentVideo[2]} onReady={this.onReady} onEnd={this.onEnd} />

		      <h3 id="aside-now-playing">{this.state.currentVideo[0]} | <i>{this.state.currentVideo[1]}</i></h3>
		      
		      <div id="twitter-button">
		      	<a href={`https://twitter.com/intent/tweet?text=${this.state.currentVideo[0]} - ${this.state.currentVideo[1]}&via=gnabagam&hashtags=MemoriesThroughMusic`} target="_blank" className="button"><i className="fa fa-twitter" aria-hidden="true"></i> Twitter</a>
		      </div>
		      
		      <div id="aside-bar">
		        <div id="playlist-button" className="button"><i className="fa fa-list-alt" aria-hidden="true"></i> Playlist</div>
		        <div className="button" onClick={this.prevSong}><i className="fa fa-step-backward" aria-hidden="true"></i> Prev</div>
		        <div className="button" onClick={this.skipSong}><i className="fa fa-step-forward" aria-hidden="true"></i> Next</div>
		        <div className="button" onClick={this.clearPlaylist}><i className="fa fa-times-circle" aria-hidden="true"></i> Clear Playlist</div>
		      </div>

		      <div id="playlist">  
		      	{this.state.playlist.length < 1 && <p>Click the <i className="fa fa-star-o" aria-hidden="true"></i> located in the top-right corner of the video thumbnails to add the song to your playlist.</p>}

		      	{
		      		this.state.playlist.map((playlistVideo, idx) => {
		      			return (
		      				<p key={idx} onClick={() => {this.videoClick(playlistVideo)}}>{playlistVideo[0]} - <i>{playlistVideo[1]}</i></p>
		      			)
		      		})
		      	}
		      	
		      </div>

		      <div id="close-now-playing" onClick={() => document.querySelector('aside').classList.add('closed')}>
		          <i className="fa fa-times" aria-hidden="true"></i> Back
		      </div>
	    	</aside>

	        <div id="input-div">
				<input type="text" value={this.state.value} placeholder="&#xf002; Search all years by song/album" id="input" onChange={this.handleInputChange} />
			</div>

	        <div id='videos'>
	          <div className="videos">

	        	{
	        		!this.state.matches && songs['_' + this.props.year].map(musicVideo => {
	        			return (
	        				<div className="video" key={musicVideo[2]}>
					            <img src={`http://img.youtube.com/vi/${musicVideo[2]}/mqdefault.jpg`} alt={`${musicVideo[0]} from the movie ${musicVideo[1]}`} onClick={() => this.videoClick(musicVideo)} />
					            <div onClick={() => this.addToPlaylistClick(musicVideo)} className="add-to-playlist"><i className="fa fa-star-o" aria-hidden="true"></i></div>
					            <p className="video-title"><strong>{musicVideo[0]}</strong><br/>{musicVideo[1]}</p>
					        </div>	
	        			)
	        		})
	        	}

	        	{
	        		this.state.matches && this.state.matches.map(musicVideo => {
	        			return (
	                  		<div className="video" key={musicVideo[2]}>
					            <img src={`http://img.youtube.com/vi/${musicVideo[2]}/mqdefault.jpg`} alt={`${musicVideo[0]} from the movie ${musicVideo[1]}`} onClick={() => this.videoClick(musicVideo)} />
					            <div onClick={() => this.addToPlaylistClick(musicVideo)} className="add-to-playlist"><i className="fa fa-star-o" aria-hidden="true"></i></div>
					            <p className="video-title"><strong>{musicVideo[0]}</strong><br/>{musicVideo[1]}</p>
					        </div>
					    )
            		})
	        	}
		      </div>
	        </div>

	        <footer>
	        	<p><Link to='/contact' id="faq-link">Questions? Ask us!</Link></p>
	    	</footer>
	      
	      </div>
	    );
  	}
}

const SecondaryHeader = () => {
	return (
		<header id='secondary-header'>
			<Link to='/'><img src={logo} alt="Gnabagam Logo" /></Link>
			<YearSelector />
			<div className="button" id="header-now-playing" onClick={() => document.querySelector('aside').classList.remove('closed')}>Watch Video</div>
		</header>
	);
}

const mapStateToProps = (state) => {
	return {
		year: state.year
	}
}

export default connect(mapStateToProps)(Secondary);



// WEBPACK FOOTER //
// ./src/components/Secondary.js